// extracted by mini-css-extract-plugin
export default {"wrapper":"Name_wrapper__KCgeA","mainTitle":"Name_mainTitle__OEakN","input":"Name_input__bwdGU"};